import React from 'react';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import CustomTypography from '../../../../components/mui/CustomTypography';
import CustomModal from '../../../../components/mui/CustomModal';
import { KeyboardShortcutsData } from '../../../../data/keyboardShortcuts';
import ShortcutBadge from '../../../../components/mui/ShortcutBadge';

const KeyboardShortcutsModal = ({ keyboardShortcutsShow, handleKeyboardShortcutsCloseModal }) => {
  return (
    <CustomModal open={keyboardShortcutsShow} onClose={handleKeyboardShortcutsCloseModal}>
      <div className="preview-dropdown-header">
        <CustomTypography weight={'medium'} size="large" id="keyboard-shortcuts-title">
          Keyboard Shortcuts
        </CustomTypography>
        <HighlightOffRoundedIcon
          onClick={handleKeyboardShortcutsCloseModal}
          className="cursor-pointer opacity-50"
          style={{ height: '28px', width: '28px' }}
        />
      </div>
      <div className="preview-dropdown-body">
        <ul className="shortcut-key-ul pt-2">
          {KeyboardShortcutsData.map((shortcut, index) => (
            <li key={index} className="shortcut-key-list">
              {shortcut.action}{' '}
              <div>
                {Array.isArray(shortcut.keys) ? (
                  shortcut.keys
                    .map((key, keyIndex) => <ShortcutBadge key={keyIndex}>{key}</ShortcutBadge>)
                    .reduce((prev, curr) => [
                      prev,
                      <span key={`${curr.key}-plus`} className="p-2">
                        +
                      </span>,
                      curr,
                    ])
                ) : (
                  <ShortcutBadge>{shortcut.keys}</ShortcutBadge>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </CustomModal>
  );
};

export default KeyboardShortcutsModal;
